import api from './client';

export const masterApi = {
  getSuppliers: (keyword) => api.get(`/api/master/suppliers${keyword ? `?keyword=${encodeURIComponent(keyword)}` : ''}`),
  getCustomerInfo: (keyword, limit, offset) => {
    const params = new URLSearchParams();
    if (keyword) params.append('keyword', keyword);
    if (limit != null) params.append('limit', String(limit));
    if (offset != null) params.append('offset', String(offset));
    const qs = params.toString();
    return api.get(`/api/master/customer-info${qs ? `?${qs}` : ''}`);
  },
  updateCustomerInfo: (dealerCode, data) => api.put(`/api/master/customer-info/${dealerCode}`, data),
  getNisugataMasters: (keyword, limit, offset, classcode0, classcode1, classcode2, excludeOther, onlyNeedsReview) => {
    const params = new URLSearchParams();
    if (keyword) params.append('keyword', keyword);
    if (limit) params.append('limit', limit);
    if (offset) params.append('offset', offset);
    if (classcode0 !== undefined && classcode0 !== null) params.append('classcode0', classcode0);
    if (classcode1 !== undefined && classcode1 !== null) params.append('classcode1', classcode1);
    if (classcode2 !== undefined && classcode2 !== null) params.append('classcode2', classcode2);
    if (excludeOther) params.append('exclude_other', 'true');
    if (onlyNeedsReview) params.append('only_needs_review', 'true');
    return api.get(`/api/master/nisugata-masters?${params.toString()}`);
  },
  getNisugataMaster: (productCode) => api.get(`/api/master/nisugata-masters/${productCode}`),
  updateNisugataMaster: (productCode, data) => api.put(`/api/master/nisugata-masters/${productCode}`, data),
  getNisugataMasterHistory: (productCode, fieldName, fromDate, toDate, limit, offset) => {
    const params = new URLSearchParams();
    if (fieldName) params.append('field_name', fieldName);
    if (fromDate) params.append('from_date', fromDate);
    if (toDate) params.append('to_date', toDate);
    if (limit) params.append('limit', limit);
    if (offset) params.append('offset', offset);
    return api.get(`/api/master/nisugata-masters/${productCode}/history?${params.toString()}`);
  },
  getNisugataMasterHistoryByBatch: (productCode, changeBatchId) => {
    const params = new URLSearchParams();
    params.append('change_batch_id', changeBatchId);
    return api.get(`/api/master/nisugata-masters/${productCode}/history/by-batch?${params.toString()}`);
  },
  getAllNisugataMasterHistory: (fieldName, fromDate, toDate, limit, offset) => {
    const params = new URLSearchParams();
    if (fieldName) params.append('field_name', fieldName);
    if (fromDate) params.append('from_date', fromDate);
    if (toDate) params.append('to_date', toDate);
    if (limit) params.append('limit', limit);
    if (offset) params.append('offset', offset);
    return api.get(`/api/master/nisugata-masters/history/all?${params.toString()}`);
  },
  importNisugataMasters: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/master/nisugata-masters/import', formData);
  },
  acknowledgeCoreSync: (productCode) =>
    api.post(`/api/master/nisugata-masters/${encodeURIComponent(productCode)}/acknowledge-core-sync`),
  getProductsByDisp: (disps) => {
    const params = new URLSearchParams();
    params.append('disps', disps.join(','));
    return api.get(`/api/master/products/by-disp?${params.toString()}`);
  },
};
